import { useContext, useEffect, useState } from 'react';
import useSWR from 'swr';
import { z } from 'zod';

import { BackStageContext } from '@/contexts/BackStageContext';

import client from '../../feathers';
import { useServiceArgs } from './types';

const useService = <T = any>({
  collectionName,
  query,
  swrConfig,
  dataSchema,
}: useServiceArgs<T>) => {
  //   // 當全域的 loading 變動時，重新觸發資料更新
  const [returnData, setReturnData] = useState<T[]>([]);
  const { backStageUpdateTrigger } = useContext(BackStageContext);

  const service = client.service(collectionName);
  const { data, mutate, isLoading, error } = useSWR<T[]>(
    [backStageUpdateTrigger, query, collectionName],
    async () => {
      const res = await service.find({ query });
      if (dataSchema) {
        return z.array(dataSchema).parse(res.data);
      }
      return res.data;
    },
    swrConfig
  );

  if (error) {
    console.error(error);
  }

  useEffect(() => {
    if (data) {
      setReturnData(data);
    }
  }, [data]);

  return [returnData, mutate, service, isLoading] as const;
};

export default useService;
